import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=d0da4aa8&scoped=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"
import style0 from "./UserDetailModal.vue?vue&type=style&index=0&id=d0da4aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0da4aa8",
  null
  
)

export default component.exports